export function cssValueOrSizeVar ( input: string | null ): string | null {
  let result = input;

  if ( input && input.startsWith( "s-" ) ) {
    result = `var(--${input})`;
  }

  return result;
}
